const MetaTrader4ContentTwo = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="contact__cards row">
          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Advanced Charting Tools</h4>
              </div>
              <p>
                Access interactive, customizable charts with over 30 built-in
                indicators and analytical objects. MT4 empowers traders to
                monitor multiple assets, identify trends, and make data-driven
                decisions in real time.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Automated Trading with Expert Advisors (EAs)</h4>
              </div>
              <p>
                Execute trades automatically using custom or pre-built Expert
                Advisors. Automate strategies, reduce manual intervention, and
                let MT4 trade around the clock based on your parameters.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Lightning-Fast Order Execution</h4>
              </div>
              <p>
                Experience ultra-low latency execution, even during volatile
                market conditions. The Pips’ MT4 servers are optimized for
                stability and precision, ensuring trades are placed instantly
                without delays.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Secure & Reliable Trading Environment</h4>
              </div>
              <p>
                With robust encryption and multi-layered security protocols, MT4
                on The Pips ensures that your data, transactions, and funds
                remain fully protected, so you can trade with complete peace of
                mind.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaTrader4ContentTwo;
